{
  "mine": {
    "title": "Mes cours",
    "subtitle": "Les cours auxquels vous êtes inscrit, et où vous en êtes.",
    "empty": "Vous n'êtes inscrit à aucun cours pour le moment.",
    "resume": "Reprendre",
    "review": "Revoir"
  },
  "player": {
    "loading": "Chargement du cours",
    "curriculum": "Programme",
    "progress": "{{done}} leçon(s) terminée(s) sur {{total}} — {{percent}} %",
    "progressLabel": "Progression dans le cours",
    "markRead": "J'ai lu cette leçon",
    "courseCompleted": "Vous avez terminé ce cours. Bravo !",
    "notEnrolledTitle": "Inscrivez-vous pour suivre ce cours",
    "notEnrolledBody": "L'inscription ouvre les leçons et enregistre votre progression.",
    "enrol": "S'inscrire à ce cours"
  },
  "state": {
    "locked": "Verrouillée",
    "available": "Disponible",
    "in_progress": "En cours",
    "completed": "Terminée"
  },
  "lockReason": {
    "exercise_not_passed": "Réussissez l'exercice de la leçon précédente pour débloquer celle-ci.",
    "awaiting_grading": "Votre copie précédente attend d'être corrigée par l'enseignant."
  },
  "attempt": {
    "start": "Commencer l'exercice",
    "submit": "Rendre ma copie",
    "retry": "Nouvelle tentative",
    "resultTitle": "Résultat",
    "passed": "Exercice réussi.",
    "failed": "Exercice non réussi.",
    "awaitingGrading": "Votre copie a été rendue. Elle attend la correction de l'enseignant.",
    "passMark": "Seuil de réussite",
    "attemptsLeft": "Tentatives restantes",
    "bestScore": "Meilleur score",
    "unlimited": "Illimitées",
    "percent": "{{value}} %"
  },
  "dashboard": {
    "title": "Mon tableau de bord",
    "subtitle": "Où vous en êtes, ce qui attend, et vos derniers résultats.",
    "inProgress": "Cours en cours",
    "awaiting": "En attente de correction",
    "awaitingEmpty": "Aucune copie en attente de correction.",
    "awaitingItem": "Votre copie de « {{course}} » attend la correction de l'enseignant.",
    "awaitingBlocking": "Votre copie de « {{course}} » attend la correction. La suite du cours reste fermée jusque-là.",
    "recent": "Derniers résultats",
    "recentEmpty": "Aucun résultat pour le moment.",
    "noScore": "Sans note"
  },
  "grading": {
    "title": "Copies à corriger",
    "subtitle": "Les copies rendues par vos élèves, les plus anciennes d'abord.",
    "empty": "Aucune copie n'attend votre correction.",
    "open": "Corriger",
    "attemptNumber": "Tentative n° {{number}}",
    "blocking": "Bloque la suite du cours pour cet élève.",
    "by": "{{student}} — {{course}} — tentative n° {{number}}",
    "instructions": "Consigne",
    "studentAnswer": "Réponse de l'élève",
    "blank": "Sans réponse",
    "autoGraded": "Corrigée automatiquement. Vous pouvez rectifier la note.",
    "manualQuestion": "Question ouverte : une note est requise.",
    "points": "Points (sur {{max}})",
    "answerFeedback": "Commentaire sur cette réponse",
    "overallFeedback": "Appréciation générale",
    "submit": "Enregistrer la correction",
    "gradedScore": "{{score}} / {{max}} — {{percent}} %",
    "revoke": "Annuler cette notation",
    "confirmRevoke": "Annuler cette notation ? L'élève perdra la note qu'il a lue, et la leçon suivante peut se refermer. La notation reste dans l'historique.",
    "history": "Historique des notations",
    "currentGrade": "note en vigueur",
    "unknownGrader": "Correcteur inconnu"
  },
  "teaching": {
    "title": "Tableau de bord",
    "subtitle": "Vos élèves, vos cours, et ce qui demande votre attention.",
    "students": "Suivis",
    "activeStudents": "Actifs (7 jours)",
    "pending": "Copies à corriger",
    "openQueue": "Ouvrir la file",
    "courses": "Mes cours",
    "noCourse": "Vous n'avez pas encore de cours.",
    "draft": "brouillon",
    "courseStats": "{{students}} inscrit(s) — {{progress}} % d'avancement moyen — {{completion}} % terminé, {{drop}} % abandonné",
    "struggling": "Élèves en difficulté",
    "strugglingEmpty": "Aucun élève ne demande votre attention.",
    "reasonInactive": "Aucune activité depuis plus de 14 jours sur « {{course}} ».",
    "reasonFailures": "{{attempts}} échecs sur « {{exercise}} », toujours non réussi.",
    "openStudent": "Voir la fiche",
    "weakest": "Exercices les moins réussis",
    "weakestEmpty": "Pas encore assez de copies pour en tirer un signal.",
    "passRate": "{{rate}} % ({{passed}}/{{total}})"
  },
  "student": {
    "title": "Fiche élève",
    "subtitle": "Sa progression dans vos cours, et ce qu'il a accepté de partager.",
    "myCourses": "Dans mes cours",
    "results": "Derniers résultats",
    "otherCourses": "Ses autres cours",
    "otherCoursesEmpty": "Il ne suit aucun autre cours.",
    "consentRequired": "Cet élève n'a pas accepté de partager sa progression hors de vos cours. Vous pouvez lui en faire la demande."
  },
  "certificates": {
    "title": "Mes attestations",
    "subtitle": "Les certificats des cours que vous avez terminés. Le numéro de vérification permet à un tiers d'en confirmer l'authenticité sans compte.",
    "empty": "Vous n'avez pas encore d'attestation. Terminez un cours pour en obtenir une.",
    "issuedOn": "Délivré le",
    "serial": "Numéro de vérification",
    "download": "Télécharger le PDF",
    "shareHint": "Faites vérifier cette attestation sur",
    "revoked": "Cette attestation a été retirée le {{date}}.",
    "nav": "Mes attestations"
  },
  "verify": {
    "title": "Vérifier un certificat",
    "subtitle": "Saisissez le numéro figurant sur l'attestation pour en confirmer l'authenticité. Aucun compte n'est nécessaire.",
    "serialLabel": "Numéro de vérification",
    "serialHint": "Les tirets et la casse sont sans importance.",
    "submit": "Vérifier",
    "valid": "Cette attestation est authentique.",
    "revoked": "Cette attestation a été retirée le {{date}} et n'est plus valide.",
    "unknown": "Aucune attestation ne correspond à ce numéro.",
    "holder": "Titulaire"
  }
}
